module.exports = __webpack_public_path__ + "img/new_img2.02c904ed.png";